import React from 'react';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { SubTitle } from 'components/atoms/Texts/SubTitle';
import { MyRankingBlock } from 'components/molecules/Blocks/MyRankingBlock';
import Cup from '../../../../assets/background/featureContainer/cup.webp';
import { MyRank } from './index';

export interface FeatureMyRankViewProps {
  ranks: MyRank[];
}

export const FeatureMyRankView = ({ ranks }: FeatureMyRankViewProps) => {
  return (
    <FeatureContainer backgroundImage={Cup}>
      <SubTitle text="Mon Classement" />
      {ranks.map((r, i) => (
        <MyRankingBlock key={i} rank={r.rank} name={r.name} />
      ))}
    </FeatureContainer>
  );
};
